import get from "lodash/get";
import omit from "lodash/omit";
import { connect } from "react-redux";
import { lifecycle, compose, mapProps } from "recompose";
import type { AnyAction } from "redux";

// We would like to remove this hoc with probably a hook, so that we can remove
// recompose as a dependency.

export default function dispatchOnMount(
  actionCreator: (...args: any[]) => AnyAction,
  actionCreatorArgs?:
    | ((props: Record<string, any>) => Record<string, any> | Record<string, any>[])
    | Array<string>
    | string
    | null,
) {
  function getActionCreatorArgs(props: Record<string, unknown>) {
    if (typeof actionCreatorArgs === "function") {
      const result = actionCreatorArgs(props);
      return Array.isArray(result) ? result : [result];
    }
    if (Array.isArray(actionCreatorArgs)) {
      return actionCreatorArgs.map((arg) => get(props, arg));
    }
    if (typeof actionCreatorArgs === "string") {
      return [get(props, actionCreatorArgs)];
    }
    return [];
  }

  const mapStateToProps = () => ({});
  const mapDispatchToProps = { __toDispatch: actionCreator };
  function componentDidMount(this: any) {
    this.props.__toDispatch(...getActionCreatorArgs(this.props));
  }

  return compose(
    connect(mapStateToProps, mapDispatchToProps),
    lifecycle({ componentDidMount }),
    mapProps((x: object) => omit(x, "__toDispatch")),
  );
}
